const PATIENT_PORTAL_HOST = /^patient([.-][a-z0-9-]+)*\.labcorp\.com$/i;

export function isPatientPortalHost(hostname: string | undefined): boolean {
  return PATIENT_PORTAL_HOST.test(hostname ?? '');
}
